<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('materialproduct_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.product')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-materialproduct-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                  {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.namefr') }}</strong></td>
              <td>
                  {{ item['namefr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.reference') }}</strong></td>
              <td>
                  {{ item['reference'] }}
              </td>
              <td><strong>{{ $t('global.hub') }}</strong></td>
              <td>
                  {{ item['public'] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'MaterialProduct';

export default {
  name: 'MaterialProductShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('materialproduct', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialproduct', ['find'])
  },
  methods: {
    ...mapActions('materialproduct', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
